import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { GetCallsFromAPI } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export function useGetCallsAndAlerts(
  searchParamString?: string,
  options?: UseQueryOptions<GetCallsFromAPI, any>
) {
  const marginCallsApiURL = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_MARGIN_CALLS}`;

  const fetchMarginCalls = async () => {
    const { data } = await axios.get(
      `${marginCallsApiURL}?${searchParamString}`,
      {
        withCredentials: true,
      }
    );
    return data as GetCallsFromAPI;
  };

  return useQuery<GetCallsFromAPI, AxiosError>(
    [queryKeys.getMarginCalls],
    fetchMarginCalls,
    {
      enabled: false,
      ...options,
    }
  );
}
